import { render, staticRenderFns } from "./CateringList.vue?vue&type=template&id=94dd2654&scoped=true"
import script from "./CateringList.vue?vue&type=script&lang=js"
export * from "./CateringList.vue?vue&type=script&lang=js"
import style0 from "./CateringList.vue?vue&type=style&index=0&id=94dd2654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94dd2654",
  null
  
)

export default component.exports